document.addEventListener('DOMContentLoaded', function () {

  const content = document.getElementById('article-content');
  const tocList = document.getElementById('toc-list');
  const progressBar = document.getElementById('reading-progress-bar');

  if (!content) return;

  // ── Slugify helper: zet koptekst om naar een URL-vriendelijke anchor-id ──
  function slugify(text) {
    return text
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // ë->e, ï->i, etc.
      .replace(/[^a-z0-9\s-]/g, '')   // leestekens/emoji weg
      .replace(/\s+/g, '-')          // spaties -> streepjes
      .replace(/-+/g, '-')           // dubbele streepjes samenvoegen
      .replace(/^-+|-+$/g, '');      // rand-streepjes weg
  }

  // ── Inhoudsopgave genereren ──
  if (tocList) {
    const headings = content.querySelectorAll('h2, h3');
    const usedIds = {};

    if (headings.length > 0) {
      headings.forEach(function (heading, index) {
        if (!heading.id) {
          let baseSlug = slugify(heading.textContent) || 'sectie-' + index;
          let slug = baseSlug;
          let counter = 2;

          // Voorkom dubbele id's bij identieke koppen
          while (usedIds[slug]) {
            slug = baseSlug + '-' + counter;
            counter++;
          }
          usedIds[slug] = true;
          heading.id = slug;
        } else {
          usedIds[heading.id] = true;
        }

        const li = document.createElement('li');
        const a = document.createElement('a');

        a.href = '#' + heading.id;
        a.textContent = heading.textContent.trim();

        if (heading.tagName === 'H3') {
          li.style.paddingLeft = '14px';
          a.style.fontSize = '12px';
          a.style.opacity = '0.85';
        }

        a.addEventListener('click', function (e) {
          e.preventDefault();
          const target = document.getElementById(heading.id);
          if (target) {
            const offset = 120;
            const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        });

        li.appendChild(a);
        tocList.appendChild(li);
      });
    } else {
      const tocContainer = document.querySelector('.news-article-toc-container');
      if (tocContainer) tocContainer.style.display = 'none';
    }
  }

  // ── Actieve heading + voortgangsbalk bij scrollen ──
  function onScroll() {

    if (progressBar) {
      const contentTop = content.getBoundingClientRect().top + window.pageYOffset;
      const contentHeight = content.offsetHeight;
      const scrolled = window.pageYOffset - contentTop;
      const progress = Math.min(Math.max((scrolled / contentHeight) * 100, 0), 100);
      progressBar.style.width = progress + '%';
    }

    if (tocList) {
      const headings = content.querySelectorAll('h2, h3');
      const links = tocList.querySelectorAll('a');
      let currentId = '';

      headings.forEach(function (heading) {
        const top = heading.getBoundingClientRect().top;
        if (top < 160) {
          currentId = heading.id;
        }
      });

      links.forEach(function (link) {
        link.classList.remove('active');
        if (currentId && link.getAttribute('href') === '#' + currentId) {
          link.classList.add('active');
        }
      });
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

});